var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-4 mb-4"},[_c('div',{staticClass:"mb-3 mt-4",staticStyle:{"position":"relative"}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('span',{staticClass:"main-title"},[_vm._v("FOOD SUMMARY |  ")]),_c('span',{staticClass:"submain-title"},[_vm._v("Store payment")])]),_c('v-flex',{staticStyle:{"display":"flex","justify-content":"flex-end"},attrs:{"xs12":"","sm6":""}},[_c('download-excel',{attrs:{"data":_vm.export_form_store_payment,"fields":{
            No: 'No',
            'Store name': 'store_name',
            Package: 'package',
            'Order type': 'order_type',
            'Bank No.': 'bank_no',
            'Bank Name': 'bank_name',
            'Bank Type': 'bank_type',
            Revenue: 'circulation',
            'Commission%': 'commission',
            'Commission paid': 'deduction',
            Paid: 'amount_paid',
            'Total paid': 'total_paid',
          },"name":'StorePaymentReport-' +
              (_vm.search_config.search_store_id == 0
                ? 'All_store'
                : _vm.store_payment_list.length > 0
                ? _vm.store_payment_list[0].store_name
                : '') +
              '_' +
              _vm.search_config.datetime_start +
              '_to_' +
              _vm.search_config.datetime_end +
              '.xls'}},[_c('v-btn',{attrs:{"flat":""}},[_c('v-icon',{attrs:{"large":"","color":"black"}},[_vm._v("print")]),_vm._v(".xls ")],1)],1),_c('download-excel',{attrs:{"type":"csv","data":_vm.export_form_store_payment,"fields":{
            No: 'No',
            'Store name': 'store_name',
            Package: 'package',
            'Bank No.': 'bank_no',
            'Bank Name': 'bank_name',
            'Bank Type': 'bank_type',
            Revenue: 'circulation',
            'Commission%': 'commission',
            'Commission paid': 'deduction',
            Paid: 'amount_paid',
            'Total paid': 'total_paid',
          },"name":'StorePaymentReport-' +
              (_vm.search_config.search_store_id == 0
                ? 'All_store'
                : _vm.store_payment_list.length > 0
                ? _vm.store_payment_list[0].store_name
                : '') +
              '_' +
              _vm.search_config.datetime_start +
              '_to_' +
              _vm.search_config.datetime_end +
              '.csv'}},[_c('v-btn',{attrs:{"flat":""}},[_c('v-icon',{attrs:{"large":"","color":"black"}},[_vm._v("print")]),_vm._v(".csv ")],1)],1)],1)],1)],1),_c('searchFood',{attrs:{"action_method":'fetchStorePaymentReport'}}),_c('storePayment')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }